import PropTypes from 'prop-types';

function MMSnacksInactive({ className, width }) {
    return (
        <svg width={width} viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
            <path
                d="M4.28096 12.8444L21.8918 7.16281C21.431 2.20682 4.25193 9.9238 3.78028 11.3388C3.71481 11.8816 3.7782 12.4322 3.96531 12.946L4.28096 12.8444Z"
                fill="#FFF9EA"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M4.99924 10.3956C4.45139 8.17161 6.01148 5.63557 9.40738 8.29497C12.8033 10.9544 9.87904 13.5086 9.87904 13.5086L6.65365 13.4251C6.65365 13.4251 5.20241 11.2337 4.99924 10.3956Z"
                fill="#FFF9EA"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeMiterlimit="10"
            />
            <path
                d="M6.71535 8.83936C5.20243 7.13415 4.87228 4.33326 9.16432 4.60536C13.4564 4.87747 13.9099 9.74639 13.9099 9.74639L10.2491 11.7418C10.2491 11.7418 7.47726 9.69196 6.71535 8.83936Z"
                fill="#FFF9EA"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeMiterlimit="10"
            />
            <path
                d="M14.5376 9.88042C12.7236 8.48723 12.3608 5.20742 15.9163 3.34983C19.7258 1.35438 19.9072 7.80514 19.9072 7.80514L17.948 10.3448L14.5376 9.88042Z"
                fill="#FFF9EA"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeMiterlimit="10"
            />
            <path
                d="M12.582 10.432C11.3303 8.51269 11.0691 4.6669 15.3612 4.939C19.6532 5.21111 18.3544 10.2433 18.3544 10.2433L15.6623 11.9993L12.582 10.432Z"
                fill="#FFF9EA"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeMiterlimit="10"
            />
            <path
                d="M7.76392 13.1129C7.2197 10.8852 8.25008 7.17007 12.2083 8.84988C16.1666 10.5297 13.2714 14.8508 13.2714 14.8508L10.1476 15.6127L7.76392 13.1129Z"
                fill="#FFF9EA"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeMiterlimit="10"
            />
            <path
                d="M14.8424 12.4494C13.5907 10.5301 14.3199 7.312 18.3108 6.73151C22.5666 6.11836 20.6147 12.2607 20.6147 12.2607L17.9226 14.0167L14.8424 12.4494Z"
                fill="#FFF9EA"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeMiterlimit="10"
            />
            <path
                d="M3.96527 12.9463C4.69136 15.0846 5.98116 16.9874 7.69859 18.4537C11.0328 21.3562 9.65776 27.9231 11.6895 28.8555C13.7212 29.7879 30.5266 26.5916 27.7185 20.5508C25.4763 15.7182 22.3271 12.1227 21.8917 7.16309L3.96527 12.9463Z"
                fill="#FFF9EA"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeMiterlimit="10"
            />
            <path
                d="M3.96527 12.9463L21.8917 7.16309C21.9573 7.77281 22.0566 8.37842 22.1892 8.97714L4.51674 14.3286L3.96527 12.9463Z"
                fill="#FFF9EA"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M13.413 15.3554C12.4806 16.8683 10.467 20.9934 14.9622 22.8075C19.4574 24.6215 21.627 20.9572 21.8556 19.4152C22.0987 17.5794 21.6343 15.3445 20.0415 14.4302C18.4488 13.5159 14.7517 13.1821 13.413 15.3554Z"
                fill="#FFF9EA"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M11.1271 22.7529L12.3352 27.6545L18.6989 25.913C18.6989 25.913 14.7661 25.5502 13.6667 25.1475C13.3257 25.0169 11.1271 22.7529 11.1271 22.7529Z"
                fill="#FFF9EA"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M14.5556 18.345C14.639 17.9169 15.2486 15.5332 17.244 15.9432C19.2395 16.3532 19.8635 17.1949 20.2481 17.9967"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M14.3707 20.1589C14.6973 20.6233 17.6759 23.1412 20.0161 20.0029"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

export default MMSnacksInactive;

MMSnacksInactive.propTypes = {
    className: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

MMSnacksInactive.defaultProps = {
    className: null,
    width: 28,
};
